<template>
	<section class="marketing-section bg-color-greige">
		<header v-if="strategiesDetails?.sectionHeading || strategiesDetails?.sectionSummary" class="container">
			<div class="text-align-center col-12 col-8-md col-offset-2-md">
				<h2 v-if="strategiesDetails?.sectionHeading" class="heading-1">
					{{ strategiesDetails.sectionHeading }}
				</h2>
				<p v-if="strategiesDetails?.sectionSummary" class="mt-150 body-xl">
					{{ strategiesDetails.sectionSummary }}</p
				></div
			>
		</header>
		<BasePlaceHolder :section-count="2" :placehold="loading" :class="{ container: loading }">
			<RealEstateStrategiesSection
				v-if="strategiesDetails"
				class="text-color-content-primary"
				:section="strategiesSection"
				:is-dark-theme="false"
			/>
		</BasePlaceHolder>
	</section>
</template>

<script setup lang="ts">
import { Ref, ref } from 'vue';
import { SanityFlagshipFundStrategies, SanityStrategiesShowcase } from 'types/sanity/marketing-components';
import { StrategiesSection, StrategyShowcaseInfo } from 'types/real-estate-strategy';
import { getFlagshipFundStrategies } from '@api/sanity/graphql/flagship-fund-strategies';
import RealEstateStrategiesSection from '@components/marketing-site/real-estate-strategies-section.vue';

const loading = ref(true);
const strategiesDetails: Ref<SanityFlagshipFundStrategies | null> = ref(null);
const strategiesSection = ref<StrategiesSection>({
	strategies: [],
	sectionDisclaimer: []
});

async function setup(): Promise<void> {
	try {
		strategiesDetails.value = await getFlagshipFundStrategies();
		loading.value = false;

		if (strategiesDetails.value && strategiesDetails.value.flagshipStrategyShowcase?.length) {
			const sanityShowcase: Array<SanityStrategiesShowcase> = strategiesDetails.value.flagshipStrategyShowcase;

			const disclaimer: Array<string> = [];
			disclaimer.push(strategiesDetails.value.sectionDisclaimer ?? '');

			const showcaseInfo: Array<StrategyShowcaseInfo> = [];

			sanityShowcase.forEach((strategy: SanityStrategiesShowcase) => {
				showcaseInfo.push({
					eyebrow: '',
					title: strategy.heading,
					summary: strategy.summary,
					featuredImages: strategy.strategyImages?.map((image) => image.asset?.url ?? ''),
					stats: strategy.strategyStats.map((stat) => ({
						key: stat.value,
						value: stat.label
					}))
				});
			});

			strategiesSection.value = {
				strategies: showcaseInfo,
				sectionDisclaimer: disclaimer
			};
		}
	} catch {}
}
setup();
</script>
